import { Pipe, PipeTransform } from "@angular/core";
import { AtmFunctionType } from "../api/api";

/** Display names for the Ghana ATM services. */
export const GHANA_ATM_SERVICE_TYPES: { id: AtmFunctionType; name: string }[] = [
  { id: AtmFunctionType.MojoPay, name: "MojoPay" },
  { id: AtmFunctionType.MtnGhana, name: "MTN" },
  { id: AtmFunctionType.Vodafone, name: "Vodafone" },
  { id: AtmFunctionType.AirtelTigo, name: "AirtelTigo" },
  { id: AtmFunctionType.Bank, name: "Bank" },
  { id: AtmFunctionType.Deposit, name: "Deposit" },
  { id: AtmFunctionType.Withdraw, name: "Withdraw" },
  { id: AtmFunctionType.Crypto, name: "Crypto" },
];

export function atmFunctionTypeName(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "";
  }
  const ghana = GHANA_ATM_SERVICE_TYPES.find((p) => p.id === value);
  if (ghana) {
    return ghana.name;
  }
  switch (value as AtmFunctionType) {
    case AtmFunctionType.Mtn:
      return "MTN Cameroon";
    case AtmFunctionType.Orange:
      return "Orange";
    case AtmFunctionType.M2U:
      return "M2U";
  }
  return String(value);
}

@Pipe({
  name: "atmFunctionType",
})
export class AtmFunctionTypePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return atmFunctionTypeName(value);
  }
}
